module.exports = __webpack_public_path__ + "img/shower rain.b38e2eb8.jpg";